import { ComponentDataDestService } from '../component-data-dest.service';
import { catchError, map, tap } from 'rxjs';
import { ComponentDataSourceService } from '../../component-data-source/component-data-source.service';
import { environment } from '../../../environment/environment';
import { notifyDunaLocationsAdminFormSuccess, refreshAllLocationTableStores } from './location-stores-refresh';

export function delete_room(
  componentDataDestService: ComponentDataDestService,
  componentDataSourceService: ComponentDataSourceService,
  data: { guid: string }
) {
  const guid = data.guid;
  if (!guid) {
    console.error('[delete_room] Missing guid');
    throw new Error('Manglende rum-id');
  }

  return componentDataDestService.http.delete(`${environment.apiUrl}/locations/rooms/${guid}`).pipe(
    catchError((error) => {
      console.error('[delete_room]', error);
      throw error;
    }),
    map((response) => response),
    tap(() => {
      refreshAllLocationTableStores(componentDataSourceService);
      notifyDunaLocationsAdminFormSuccess();
    })
  );
}
